module.exports = __webpack_public_path__ + "img/index-banner-2.5576f2b0.jpg";